import React from "react";
import { Map, Marker} from "@vis.gl/react-google-maps";
import Typography from "@mui/material/Typography";
import {MAPS_API_KEY} from "../../utils/constant";
import {APIProvider} from "@vis.gl/react-google-maps";
const CustomMap = () => {
    // shows marker on London by default

    const markerLocation ={
        lat: 18.909722,
        lng: -70.762778,
    };

    return (
        <div className="map-container" id='location'>
            <Typography variant="h3" sx={{color: "var(--primary-color)", fontSize: '30px', fontWeight: 'bold', marginY: '40px'}} className='section-title'>UBICACIÓN</Typography>
            <APIProvider apiKey={MAPS_API_KEY}>
                <Map
                    style={{ width: '100%', height: '650px' }}
                    defaultZoom={13}
                    defaultCenter={markerLocation}
                    gestureHandling={"none"}
                    disableDefaultUI
                >
                    <Marker position={markerLocation} />
                </Map>
            </APIProvider>
        </div>
    );
}

export default CustomMap;
